import {defineMessages} from 'react-intl';

const messages = defineMessages({
    requiredField: {
        id: 'join.errors.required_field',
        defaultMessage: 'Поле обязательно для заполнения'
    },
    invalidEmail: {
        id: 'join.errors.email_invalid',
        defaultMessage: 'E-mail указан неверно'
    },
    invalidPhone: {
        id: 'join.errors.phone_invalid',
        defaultMessage: 'Номер телефона указан неверно'
    },
    invalidPromo: {
        id: 'join.errors.promo_length_error',
        defaultMessage: 'Максимум 4 символа'
    }
});

const FastRegistrationFormValidation = function(values) {
    let errors = {};

    const emailRegex = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;

    if (!values.type || (values.type != 1 && values.type != 2)) {
        errors.type = messages.requiredField;
    }

    if (values.type == 1) {
        if ((!values.phone || !values.phone.length)) {
            errors.phone = messages.requiredField;
        } else if (/^\d+$/.test(values.phone) === false) {
            errors.phone = messages.invalidPhone;
        }
    } else if (values.type == 2) {
        if (!values.email || !values.email.length) {
            errors.email = messages.requiredField;
        } else if (emailRegex.test(values.email) === false) {
            errors.email = messages.invalidEmail;
        }
    }

    if (values.promo && values.promo.length > 4) {
        errors.promo = messages.invalidPromo;
    }

    if (!values.accountResourceId) {
        errors.accountResourceId = messages.requiredField;
    }

    return errors;
};

export default FastRegistrationFormValidation;



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/fast/FastRegistrationFormValidation.js